import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import { WaitlistProvider } from './components/context/waitlist-context';
import { SignUpProvider } from './components/context/signup-context';
import { KycProvider } from './components/context/business-kyc-context';

// A stale deploy's chunk request can come back as an HTML fallback page
// instead of a real 404, which the browser then tries to execute as JS —
// that surfaces as a raw, uncaught "Unexpected token '<'" SyntaxError
// outside of React's render tree, so a React error boundary alone can't
// catch it. Reload once (guarded) to recover automatically.
const STALE_CHUNK_RELOAD_KEY = "stale-asset-reload-attempted";
const isStaleAssetError = (message?: string) =>
  !!message && /Unexpected token '<'/i.test(message);

window.addEventListener("error", (event) => {
  if (isStaleAssetError(event?.message) && sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) !== "1") {
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, "1");
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Router>
    
    <KycProvider>
    <WaitlistProvider>
      <SignUpProvider>
        <App />
      </SignUpProvider>
    </WaitlistProvider>
</KycProvider>

  </Router>
);

